export default __webpack_public_path__ + "static/media/flatout-black.ab148068.jpg";